import React, { useState, useEffect } from 'react';
import { BookOpen, TrendingUp, Zap } from 'lucide-react';
import { GlassCard } from '../shared';
import api from '../../services/api';

/**
 * UserStats — affiche les statistiques de l'utilisateur
 * (nombre de versets lus, progression du mois, points, etc.)
 */
export const UserStats = ({ user }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        // Récupérer les stats depuis l'API
        const response = await api.get('/auth/me/stats');
        setStats(response.data);
      } catch (err) {
        console.error('Error fetching stats:', err);
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchStats();
    }
  }, [user]);

  if (loading || !stats) return null;

  const statItems = [
    {
      icon: BookOpen,
      label: 'Versets lus',
      value: stats.verses_read || 0,
      color: 'from-emerald-500/20 to-emerald-900/20',
    },
    {
      icon: TrendingUp,
      label: 'Progression',
      value: `${stats.monthly_progress || 0}%`,
      color: 'from-blue-500/20 to-blue-900/20',
    },
    {
      icon: Zap,
      label: 'Points',
      value: stats.points || 0,
      color: 'from-amber-500/20 to-amber-900/20',
    },
  ];

  return (
    <div className="grid grid-cols-3 gap-3" data-testid="user-stats">
      {statItems.map((item) => {
        const Icon = item.icon;
        return (
          <GlassCard 
            key={item.label}
            className={`bg-gradient-to-br ${item.color} text-center p-3`}
            data-testid={`stat-${item.label.toLowerCase()}`}
          >
            <Icon className="w-5 h-5 text-primary mx-auto mb-2" />
            <div className="text-2xl font-bold text-text-primary">{item.value}</div>
            <div className="text-xs text-text-muted mt-1">{item.label}</div>
          </GlassCard>
        );
      })}
    </div>
  );
};

export default UserStats;
